import PropTypes from 'prop-types';
import { getStoreCountryName } from '../../../../scripts/utils/multiTenancyHeaders';

export const FORM_FIELD_DATA_ATTRS = {
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  PHONE: 'phone',
  COMPANY: 'company',
  ADDRESS1: 'address1',
  ADDRESS2: 'address2',
  CITY: 'city',
  COUNTRY: 'country',
  PROVINCE: 'province',
  ZIP: 'zip',
};

export const FORM_INPUT_IDS = {
  FIRST_NAME: 'checkout_shipping_address_first_name',
  LAST_NAME: 'checkout_shipping_address_last_name',
  PHONE: 'checkout_shipping_address_phone',
  COMPANY: 'checkout_shipping_address_company',
  ADDRESS1: 'checkout_shipping_address_address1',
  ADDRESS2: 'checkout_shipping_address_address2',
  ADDRESS2_VISIBLE: 'checkout_shipping_address_address2_visible',
  CITY: 'checkout_shipping_address_city',
  COUNTRY: 'checkout_shipping_address_country',
  PROVINCE: 'checkout_shipping_address_province',
  ZIP: 'checkout_shipping_address_zip',
  ADDRESS_ID: 'checkout_shipping_address_id',
};

export const EMPTY_ADDRESS = {
  address1: '',
  address2: '',
  city: '',
  country: getStoreCountryName(),
  countryCode: window.Jbhifi.storeLocation,
  zip: '',
  province: '',
  provinceCode: '',
  company: '',
  longitude: 0,
  latitude: 0,
};

export const EMPTY_ADDRESS_PROPTYPES = {
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  countryCode: PropTypes.string,
  zip: PropTypes.string,
  province: PropTypes.string,
  provinceCode: PropTypes.string,
  company: PropTypes.string,
};

export const ADDRESS_LOOKUP_THEME = {
  container: 'address-lookup__container',
  containerOpen: 'address-lookup__container--open',
  input: 'address-lookup__input field__input',
  inputOpen: 'address-lookup__input--open',
  inputFocused: 'address-lookup__input--focused',
  suggestionsContainer: 'address-lookup__results-container',
  suggestionsContainerOpen: 'address-lookup__results-container--open',
  suggestionsList: 'address-lookup__results-list',
  suggestion: 'address-lookup__result',
  suggestionFirst: 'address-lookup__result--first',
  suggestionHighlighted: 'address-lookup__result--highlighted',
  sectionContainer: 'address-lookup__section-container',
  sectionContainerFirst: 'address-lookup__section-container--first',
  sectionTitle: 'address-lookup__section-title',
};

export const CARRIER_NAMES = {
  tollPriority: 'Toll Priority',
  ausPost: 'Australia Post',
  uber: 'Uber',
};

export const EXPERIENCE_NAMES = {
  asap: 'ASAP',
  scheduled: 'Scheduled',
  standard: 'Standard',
  express: 'Express',
};

export const SHIPPING_TITLES = {
  clickAndCollect: 'Click & Collect',
};
